import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link, useHistory, useParams } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { MenuItem, Select, TextField } from "@mui/material";
import {
  addCoinNetwork,
  getCoin,
  getCoinNetworkById,
  updateCoinNetwork,
} from "../../../service/api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { FaArrowLeft, FaPlus } from "react-icons/fa";
import CustomPagination from "../Pagination/pagination";
import moment from "moment";
import { Delete, Edit } from "@material-ui/icons";

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  // border: '1px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const NetworkProfile = () => {
  const [roleInput, setroleInput] = useState({
    coin: "",
    networks: [],
  });
  console.log("roleInput: ", roleInput);
  const [pair, setPair] = useState({
    chainName: "",
    address: "",
    IsDepositEnable: false,
    IsWithdrawEnable: false,
  });

  const [roleInputError, setroleInputError] = useState({
    coin: false,
    IsDepositEnable: false,
    networks: false,
  });
  const [currencyList, setCurrencyList] = useState([
    {
      networkName: "Ethereum",
    },
    {
      networkName: "Polygon",
    },
    {
      networkName: "Binance",
    },
    {
      networkName: "Tron",
    },
    {
      networkName: "Bitcoin",
    },
    {
      networkName: "Solana",
    },
  ]);
  const [pairList, setPairList] = useState([]);
  console.log("currencyList: ", currencyList);
  const [coinList, setCoinList] = useState([]);
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [page, setPage] = useState(1);
  const history = useHistory();
  const params = useParams();
  console.log("id: ", params?.id);
  const roleChange = (e) => {
    setroleInput({ ...roleInput, [e.target.name]: e.target.value });
    setroleInputError({ ...roleInputError, [e.target.name]: false });
  };
  const roleChange2 = (e) => {
    setPair({ ...pair, [e.target.name]: e.target.value });
    setroleInputError({ ...roleInputError, [e.target.name]: false });
  };

  const handleAdd = () => {
    if (!roleInput.coin) {
      return toast.warn("Please select coin first");
    }
    if (roleInput?.networks?.some((obj) => obj.chainName === pair.chainName)) {
      toast.warn("Currency already included");
      return;
    }
    if (!pair.chainName) {
      return toast.warn("Please select chain name");
    }
    if (pair.address) {
      setroleInput((prevState) => ({
        ...prevState,
        networks: [...(prevState.networks || []), pair],
      }));

      setPair({
        chainName: "",
        address: "",
        IsWithdrawEnable: false,
        IsDepositEnable: false,
      });
    } else {
      toast.warn("Please Enter a Valid Chain Address");
    }
  };

  const handleDelete = (index) => {
    const updatedPairs = roleInput.networks.filter((_, i) => i !== index);
    setroleInput({
      ...roleInput,
      networks: updatedPairs,
    });
  };

  const handleAddForm = () => {
    try {
      setLoading(true);
      addCoinNetwork(roleInput)
        .then((res) => {
          console.log("res: ", res);
          if (res?.status) {
            toast.success(res?.message, { toastId: 'network-profile-save-success' });
            history.push("/admin/network");
          } else {
            toast.error(res?.message, { toastId: 'network-profile-error' });
          }
        })
        .catch((e) => {
          setLoading(false);
          toast.error(e?.response?.data?.message, { toastId: 'network-profile-error' });
        })
        .finally((res) => {
          setLoading(false);
        });
    } catch (error) {}
  };
  const handleUpdateForm = () => {
    try {
      setLoading(true);
      updateCoinNetwork({ networks: roleInput.networks }, params?.id)
        .then((res) => {
          history.push("/admin/network");
        })
        .catch((e) => {
          setLoading(false);
          toast.error(e?.response?.data?.message, { toastId: 'network-profile-error' });
        })
        .finally((res) => {
          setLoading(false);
        });
    } catch (error) {}
  };
  const getDataById = () => {
    try {
      setLoading(true);
      getCoinNetworkById(params?.id)
        .then((res) => {
          if (res?.data?.coin?._id) {
            setEdit(true);
          }
          setroleInput({
            ...res?.data,
            coin: res?.data?.coin?._id,
            coindetails: res?.data?.coin,
          });
          console.log("responce: ", res);
        })
        .catch((e) => {
          setLoading(false);
          toast.error(e?.response?.data?.message, { toastId: 'network-profile-error' });
        })
        .finally((res) => {
          setLoading(false);
        });
    } catch (error) {}
  };
  const getCoinList = () => {
    let body = {
      page: page,
      sizePerPage: 10,
      pagination: false,
    };

    setLoading(true);
    getCoin(body)
      .then((res) => {
        console.log("res---->", res);
        if (res?.status) {
          setCoinList(res?.data?.result);
          // dispatch(actions.setUserList(res?.data?.result));
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getCoinList();
    if (params?.id !== "new") getDataById();
  }, [params?.id]);
  const handleEdit = (event, index) => {
    const getNetworks = [...roleInput.networks];
    getNetworks[index][event.target.name] = event.target.value;
    setroleInput({ ...roleInput, networks: getNetworks });
  };
  return (
    <>
      <SidebarNav />

      <div
        className="page-wrapper"
        style={{
          position: "relative",
          display: "none",
        }}
      >
        {loading && (
          <div
            className="his-spin"
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
              left: 0,
              top: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <Spin size="large" style={{ position: "relative", top: "35%" }} />
          </div>
        )}
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Add Coin Network</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Coin Network</li>
                </ul>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12" style={{ paddingBottom: "50px" }}>
              <div>
                <div style={{ margin: "10px" }} className="page-grid">
                  <div>
                    <InputLabel
                      id="demo-simple-select-label"
                      style={{ marginLeft: "7px" }}
                    >
                      Coin &nbsp;
                      {roleInputError?.name && (
                        <small style={{ color: "red" }}>
                          {"Coin is required"}
                        </small>
                      )}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      className="form-control"
                      value={roleInput?.coin}
                      onChange={roleChange}
                      disabled={edit}
                      name="coin"
                      style={{
                        border: "none",
                        padding: 0,
                        height: "56px",
                      }}
                    >
                      {coinList &&
                        coinList?.length > 0 &&
                        coinList?.map((item, _id) => {
                          return (
                            <MenuItem
                              key={_id}
                              style={{ height: "50px" }}
                              value={item?._id}
                            >
                              {item?.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </div>
                </div>
                <div style={{ margin: "10px" }} className="page-grid">
                  <div>
                    <InputLabel
                      id="demo-simple-select-label"
                      style={{ marginLeft: "7px" }}
                    >
                      Chain Name &nbsp;
                      {roleInputError?.name && (
                        <small style={{ color: "red" }}>
                          {"Currency List is required"}
                        </small>
                      )}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      className="form-control"
                      value={pair?.chainName}
                      onChange={(e) =>
                        setPair({ ...pair, chainName: e.target.value })
                      }
                      name="name"
                      style={{
                        border: "none",
                        padding: 0,
                        height: "56px",
                      }}
                    >
                      {currencyList
                        ?.filter(
                          (currency) =>
                            !roleInput.networks?.some(
                              (network) =>
                                network.chainName === currency.networkName
                            )
                        )
                        ?.map((item, _id) => {
                          return (
                            <MenuItem
                              key={`chainName-${_id}`}
                              style={{ height: "50px" }}
                              value={item.networkName}
                            >
                              {item?.networkName}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </div>
                  <div>
                    <InputLabel
                      id="demo-simple-select-label"
                      style={{ marginLeft: "7px" }}
                    >
                      Chain Address&nbsp;
                      {roleInputError?.address && (
                        <small style={{ color: "red" }}>
                          {"Min Amount is required"}
                        </small>
                      )}
                    </InputLabel>
                    <TextField
                      variant="outlined"
                      style={{
                        // width: "370px",
                        marginLeft: "5px",
                        height: "100%",
                      }}
                      className="form-control"
                      type="text"
                      placeholder="0x12xxxxxxxxxxxxxxxxxxxxx "
                      value={pair?.address}
                      onChange={(e) =>
                        setPair({ ...pair, address: e.target.value })
                      }
                      name="address"
                      id="address"
                    />
                  </div>
                  <div>
                    <InputLabel
                      id="demo-simple-select-label"
                      style={{ marginLeft: "7px" }}
                    >
                      Depositable &nbsp;
                      {roleInputError?.IsDepositEnable && (
                        <small style={{ color: "red" }}>
                          {"P2P is required"}
                        </small>
                      )}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      className="form-control"
                      value={pair.IsDepositEnable}
                      onChange={roleChange2}
                      name="IsDepositEnable"
                      style={{
                        border: "none",
                        padding: 0,
                        height: "56px",
                      }}
                    >
                      <MenuItem style={{ height: "50px" }} value={true}>
                        Yes
                      </MenuItem>
                      <MenuItem style={{ height: "50px" }} value={false}>
                        No
                      </MenuItem>
                    </Select>
                  </div>
                  <div>
                    <InputLabel
                      id="demo-simple-select-label"
                      style={{ marginLeft: "7px" }}
                    >
                      Withdrawable &nbsp;
                      {roleInputError?.IsWithdrawEnable && (
                        <small style={{ color: "red" }}>
                          {"P2P is required"}
                        </small>
                      )}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      className="form-control"
                      value={pair.IsWithdrawEnable}
                      onChange={roleChange2}
                      name="IsWithdrawEnable"
                      style={{
                        border: "none",
                        padding: 0,
                        height: "56px",
                      }}
                    >
                      <MenuItem style={{ height: "50px" }} value={true}>
                        Yes
                      </MenuItem>
                      <MenuItem style={{ height: "50px" }} value={false}>
                        No
                      </MenuItem>
                    </Select>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "8px",
                      border: "2px solid grey",
                      height: "56px",
                      width: "56px",
                      cursor: "pointer",
                      marginTop: "20px",
                    }}
                    onClick={() => handleAdd()}
                  >
                    <FaPlus />
                  </div>
                </div>
                <div style={{ marginTop: "20px" }}>
                  {roleInput.networks && roleInput.networks.length > 0 && (
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            Chain Name
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            Chain Address
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            Depositable
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            Withdrawable
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {roleInput.networks?.map((p, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              {p.chainName}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              <input
                                type="text"
                                name="address"
                                id="address"
                                onChange={(e) => {
                                  handleEdit(e, index);
                                }}
                                className="chain_address"
                                style={{
                                  width: "100%",
                                  outline: "none",
                                  border: "none",
                                  backgroundColor: "unset",
                                }}
                                value={p.address}
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                className="form-control"
                                value={p.IsDepositEnable}
                                onChange={(e) => {
                                  handleEdit(e, index);
                                }}
                                name="IsDepositEnable"
                                style={{
                                  border: "none",
                                  padding: 0,
                                  height: "56px",
                                }}
                              >
                                <MenuItem
                                  style={{ height: "50px" }}
                                  value={true}
                                >
                                  Yes
                                </MenuItem>
                                <MenuItem
                                  style={{ height: "50px" }}
                                  value={false}
                                >
                                  No
                                </MenuItem>
                              </Select>
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                className="form-control"
                                value={p.IsWithdrawEnable}
                                onChange={(e) => {
                                  handleEdit(e, index);
                                }}
                                name="IsWithdrawEnable"
                                style={{
                                  border: "none",
                                  padding: 0,
                                  height: "56px",
                                }}
                              >
                                <MenuItem
                                  style={{ height: "50px" }}
                                  value={true}
                                >
                                  Yes
                                </MenuItem>
                                <MenuItem
                                  style={{ height: "50px" }}
                                  value={false}
                                >
                                  No
                                </MenuItem>
                              </Select>
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                margin: "auto",
                              }}
                            >
                              <Delete
                                fontSize="100px"
                                onClick={() => handleDelete(index)}
                                color="red"
                                style={{
                                  cursor: "pointer",
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                {roleInput.networks && roleInput.networks.length > 0 && (
                  <>
                    {edit ? (
                      <div className="">
                        <button
                          disabled={loading}
                          onClick={() => {
                            handleUpdateForm();
                          }}
                          data-bs-toggle="modal"
                          className="btn btn-primary float-end mt-2"
                        >
                          Update
                        </button>
                      </div>
                    ) : (
                      <div className="">
                        <button
                          onClick={() => {
                            handleAddForm();
                          }}
                          data-bs-toggle="modal"
                          className="btn btn-primary float-end mt-2"
                        >
                          Add
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button> */}
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default NetworkProfile;
